module.exports = __webpack_public_path__ + "static/media/9.dd090f1a.png";